import React from 'react';
import { AlertTriangle } from 'lucide-react';

import { Button } from '@/components/ui/button';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-[320px] items-center justify-center">
          <div className="w-full max-w-lg rounded-2xl border border-red-500/20 bg-slate-800 p-6 text-slate-300 shadow-xl">
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-500/10 text-red-400">
              <AlertTriangle className="h-6 w-6" />
            </div>
            <h2 className="text-2xl font-semibold text-white">Something went wrong</h2>
            <p className="mt-2 text-sm text-slate-400">
              An unexpected rendering error interrupted this view.
            </p>
            {this.state.error ? (
              <div className="mt-4 text-left">
                <p className="font-bold text-red-400">{this.state.error.message}</p>
                <pre className="mt-2 overflow-auto rounded-xl border border-red-500/10 bg-slate-900/80 p-4 text-xs text-red-300">
                  {this.state.error.stack}
                </pre>
              </div>
            ) : null}
            <Button
              className="mt-5 bg-red-500 text-white hover:bg-red-400"
              onClick={() => window.location.reload()}
            >
              Reload page
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
